import { PayrollReportView } from '@zorro/clients';

export enum PayrollReportMode {
  BASIC = 'BASIC',
  ADVANCED = 'ADVANCED',
}

export enum DisplayActionType {
  CHANGE_AMOUNTS = 'CHANGE_AMOUNTS',
  ADD_AMOUNTS = 'ADD_AMOUNTS',
  REMOVE_AMOUNTS = 'REMOVE_AMOUNTS',
  RETROACTIVE_CHANGE = 'RETROACTIVE_CHANGE',
  ONE_TIME_CORRECTION = 'ONE_TIME_CORRECTION',
}

export type PayrollRow = {
  // Employee details
  firstName: string;
  lastName: string;
  employeeId: string;
  idFromEmployer?: string | null;
  subEntity?: string | null;
  subEntity2?: string | null;
  email: string;
  dateOfBirth: string;
  state?: string | null;
  employeeClass: string;
  terminationDate?: string | null;

  // Payroll summary
  actionType?: DisplayActionType | null;
  deduction: number;
  reimbursement: number;
  employerContribution: number;
  effectiveFrom: string;
  effectiveUntil: string;
  lastUpdate?: string | null;

  // Medical plan details
  medicalPlanType?: string;
  medicalPlanCarrier?: string | null;
  medicalPlanName?: string | null;
  medicalPlanPremium?: number | null;
  medicalPlanEmployerAllowance?: number | null;
  medicalPlanEmployeeContribution?: number | null;
  medicalPlanEmployeeSelfPayment?: number | null;
  planMarket?: string | null;
  isHsaEligible?: string;
  onboardingPeriodId: string;

  // Payroll summary for one time correction
  shouldShowPayrollForOneTimeCorrection: boolean;
  oneTimeDeduction: number | null;
  oneTimeReimbursement: number | null;
  oneTimeEmployerContribution: number | null;
  oneTimeEffectiveFrom: string | null;
  oneTimeEffectiveUntil: string | null;
  oneTimeLastUpdate?: string | null;

  // Medical plan details for one time correction
  shouldShowEnrollmentForOneTimeCorrection: boolean;
  oneTimeMedicalPlanType?: string | null;
  oneTimeMedicalPlanCarrier?: string | null;
  oneTimeMedicalPlanName?: string | null;
  oneTimeMedicalPlanPremium?: number | null;
  oneTimeMedicalPlanEmployerAllowance?: number | null;
  oneTimeMedicalPlanEmployeeContribution?: number | null;
  oneTimeMedicalPlanEmployeeSelfPayment?: number | null;
  oneTimePlanMarket?: string | null;
  oneTimeIsHsaEligible?: string;
};

type PayrollRowData = {
  isLoading: boolean;
  data: PayrollRow[] | undefined;
};

export type PayrollViewToDataMap = Map<PayrollReportView, PayrollRowData>;
